export enum ertUserSizes {
  "-- None --",
  "Small",
  "Medium",
  "Large",
  "X-Large",
  "2X-Large",
  "3X-Large",
}
